import { z } from 'zod';

export const cognitoUserSchema = z.strictObject({
  Username: z.string(),
  sub: z.guid(),
  email: z.string(),
  email_verified: z.string().optional(),
  family_name: z.string().optional(),
  given_name: z.string().optional(),
  name: z.string(), // This is autopopulated by CIS2.
});
export type CognitoUser = z.infer<typeof cognitoUserSchema>;

const UserInfoSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
});

export type UserInfo = z.infer<typeof UserInfoSchema>;
export default UserInfoSchema;
